// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".eb-cookie[data-v-16c95383]{background:var(--panel-background);border-radius:1rem;bottom:0;box-shadow:var(--panel-shadow);display:block;left:auto;margin:1rem;max-width:400px;overflow:hidden;padding:1rem;position:fixed;right:0;width:90%!important;z-index:1000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
